// extracted by mini-css-extract-plugin
export default {"summary":"TaskSmartDeliveryPage_summary__WvXhU","title":"TaskSmartDeliveryPage_title__2mibs","navigationIcon":"TaskSmartDeliveryPage_navigationIcon__GDQKZ"};